export default class FechamentoMensal {
    constructor(http) {
        this._resource = http
    }

    fechamentoMensal(tkn) {
        let url = "integracoes/zip/fechamentoMensal?_link=" + tkn;
        return this._resource.get(url).then(success => {
            return success;
        },
            failed => {
                return failed;
            })
    }


}


// WEBPACK FOOTER //
// ./src/domain/fechamentoMensal/FechamentoMensal.js